






import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class SessionWrapper extends Vue {

}
